import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';
import ImageUpload from './ImageUpload';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import { API_URL } from '../../Constants';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});


let apiUrl = API_URL;



export default function UploadFiles() {

    const [data, setData] = useState([]);
    const [commerceName, setCommerceName] = useState('');

    const [recargo, setRecarga] = useState(1);

    const efecinco = (change) => {
        console.log("efecinco");
        setRecarga(recargo + change);
    }

    useEffect(() => {
        if (localStorage.getItem('commerceUuid') == null) {
            window.location = '/';
        }

        fetch(apiUrl + '/v1/credits/commerce-load-documents/' + localStorage.getItem('commerceUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setData(res);
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });

        fetch(apiUrl + '/v1/commerces/' + localStorage.getItem('commerceUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setCommerceName(res.name);
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });


    }, [recargo]);

    const handleBackToHome = () => {
        window.location = '/commerce';
    }

    return (
        <React.Fragment>
            <Header />
            <Container maxWidth="lg">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={10}>
                            <h1 style={{ color: '#161e55' }}>Carga de documentos</h1>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Nombre</TableCell>
                                            <TableCell align="center">Documento</TableCell>
                                            <TableCell align="center">Estado de viabilidad</TableCell>
                                            <TableCell align="center">Factura</TableCell>
                                            <TableCell align="center">Pagaré</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => (
                                            <TableRow
                                                key={row.client.uuid}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="center">{row.client.name} {row.client.lastName}</TableCell>
                                                <TableCell align="center">{row.client.documentType} - {row.client.documentNumber}</TableCell>
                                                <TableCell align="center">{row.status}</TableCell>
                                                <TableCell align="center">
                                                    {row.invoiceUuid == null ? <ImageUpload clientUuid={row.client.uuid} name={'invoice'} efecinco={efecinco}></ImageUpload> :
                                                        <DownloadDoneIcon />}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.promissoryNoteUuid == null ? <ImageUpload clientUuid={row.client.uuid} name={'promissoryNote'} efecinco={efecinco}></ImageUpload> :
                                                        <DownloadDoneIcon />}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <br />
                            <ButtonPrincipal variant="contained" onClick={handleBackToHome}>Volver</ButtonPrincipal>
                            <br />
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}